var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 127,
    viewBox: "0 0 233 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.98 26.889V32.819",
    stroke: "#FFA940",
    strokeWidth: 0.9592,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.721 23.2391V34.6391",
    stroke: "#FFA940",
    strokeWidth: 0.9592,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 20.0391V37.8291",
    stroke: "#FFA940",
    strokeWidth: 0.9592,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.4 30.9891V25.0591",
    stroke: "#FFA940",
    strokeWidth: 0.9592,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.66 34.6391V23.2391",
    stroke: "#FFA940",
    strokeWidth: 0.9592,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.1 26.889V32.819",
    stroke: "#FFA940",
    strokeWidth: 0.9592,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.84 23.2391V34.6391",
    stroke: "#FFA940",
    strokeWidth: 0.9592,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.119 20.0391V37.8291",
    stroke: "#FFA940",
    strokeWidth: 0.9592,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.52 30.9891V25.0591",
    stroke: "#FFA940",
    strokeWidth: 0.9592,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.789 34.6391V23.2391",
    stroke: "#FFA940",
    strokeWidth: 0.9592,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.23 26.889V32.819",
    stroke: "#FFA940",
    strokeWidth: 0.9592,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.961 23.2391V34.6391",
    stroke: "#FFA940",
    strokeWidth: 0.9592,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.24 20.0391V37.8291",
    stroke: "#FFA940",
    strokeWidth: 0.9592,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.65 30.9891V25.0591",
    stroke: "#FFA940",
    strokeWidth: 0.9592,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.91 34.6391V23.2391",
    stroke: "#FFA940",
    strokeWidth: 0.9592,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8997 116.829L37.7297 111.909C38.6697 110.299 39.2097 108.419 39.2097 106.419C39.2097 100.399 34.3297 95.5293 28.3197 95.5293C22.3097 95.5293 17.4297 100.409 17.4297 106.419C17.4297 112.429 22.3097 117.309 28.3197 117.309C31.0897 117.309 33.6197 116.269 35.5497 114.569L39.8997 116.829Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.221 75.2395C159.754 75.2395 166.671 68.3223 166.671 59.7895C166.671 51.2567 159.754 44.3395 151.221 44.3395C142.689 44.3395 135.771 51.2567 135.771 59.7895C135.771 68.3223 142.689 75.2395 151.221 75.2395Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.091 73.0895C159.623 73.0895 166.541 66.1723 166.541 57.6395C166.541 49.1067 159.623 42.1895 151.091 42.1895C142.558 42.1895 135.641 49.1067 135.641 57.6395C135.641 66.1723 142.558 73.0895 151.091 73.0895Z",
    fill: "#FFE8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.74 63.2794C153.15 64.2094 158.28 60.5694 159.21 55.1594",
    stroke: "#FFA940",
    strokeWidth: 0.9592,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.72 56.7394C144.256 56.7394 144.69 56.3052 144.69 55.7694C144.69 55.2337 144.256 54.7994 143.72 54.7994C143.184 54.7994 142.75 55.2337 142.75 55.7694C142.75 56.3052 143.184 56.7394 143.72 56.7394Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.411 49.3295C153.947 49.3295 154.381 48.8952 154.381 48.3595C154.381 47.8238 153.947 47.3895 153.411 47.3895C152.876 47.3895 152.441 47.8238 152.441 48.3595C152.441 48.8952 152.876 49.3295 153.411 49.3295Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.122 96.3002L184.648 100.615L188.963 108.089L196.437 103.774L192.122 96.3002Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5009 64.4783L21.4785 62.9023L19.9026 66.9247L23.9249 68.5006L25.5009 64.4783Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.921 38.1072L219.898 36.5312L218.323 40.5536L222.345 42.1295L223.921 38.1072Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.822 1.15039L190.852 10.5204L199.442 6.67039L191.822 1.15039Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.581 81.2494L203.091 73.6094L199.211 82.1794L208.581 81.2494Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.8 78.7391C181.42 78.7391 181.05 78.5991 180.76 78.3091L178.06 75.6091C177.49 75.0391 177.49 74.0991 178.06 73.5291C178.63 72.9591 179.57 72.9591 180.14 73.5291L182.84 76.2291C183.41 76.7991 183.41 77.7391 182.84 78.3091C182.55 78.5991 182.17 78.7391 181.8 78.7391Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5413 60.2291C38.8834 60.2291 39.9713 59.1412 39.9713 57.7991C39.9713 56.4571 38.8834 55.3691 37.5413 55.3691C36.1993 55.3691 35.1113 56.4571 35.1113 57.7991C35.1113 59.1412 36.1993 60.2291 37.5413 60.2291Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.662 5.96078C104.397 5.96078 104.992 5.36532 104.992 4.63078C104.992 3.89624 104.397 3.30078 103.662 3.30078C102.927 3.30078 102.332 3.89624 102.332 4.63078C102.332 5.36532 102.927 5.96078 103.662 5.96078Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3423 84.1808C29.1376 84.1808 29.7823 83.5361 29.7823 82.7408C29.7823 81.9455 29.1376 81.3008 28.3423 81.3008C27.5471 81.3008 26.9023 81.9455 26.9023 82.7408C26.9023 83.5361 27.5471 84.1808 28.3423 84.1808Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.102 111.62C230.991 111.62 231.712 110.9 231.712 110.01C231.712 109.121 230.991 108.4 230.102 108.4C229.213 108.4 228.492 109.121 228.492 110.01C228.492 110.9 229.213 111.62 230.102 111.62Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.081 7.53055C156.97 7.53055 157.691 6.80973 157.691 5.92055C157.691 5.03137 156.97 4.31055 156.081 4.31055C155.192 4.31055 154.471 5.03137 154.471 5.92055C154.471 6.80973 155.192 7.53055 156.081 7.53055Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.14 10.5L108.93 22.02",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6016 2.05078L49.4016 20.7308",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.550781 55.6098L15.9908 54.7598",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.58 114.19L147.77 97.6699",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.711 92.9607L141.721 82.4707",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.08 25.9902C211.35 39.1802 204.13 53.3102 190.93 57.5802",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.79 41.3695C190.699 41.3695 195.49 36.579 195.49 30.6695C195.49 24.7601 190.699 19.9695 184.79 19.9695C178.88 19.9695 174.09 24.7601 174.09 30.6695C174.09 36.579 178.88 41.3695 184.79 41.3695Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.809 39.9195C191.719 39.9195 196.509 35.129 196.509 29.2195C196.509 23.3101 191.719 18.5195 185.809 18.5195C179.9 18.5195 175.109 23.3101 175.109 29.2195C175.109 35.129 179.9 39.9195 185.809 39.9195Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.63 29.8595C191.32 33.3095 182.96 33.3895 182.96 33.3895C182.96 33.3895 180.3 25.6895 183.38 24.0395C187.12 22.0395 187.5 26.9495 187.5 26.9495C187.5 26.9495 192 25.8595 191.63 29.8595Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.141 25.1495C176.771 28.4995 177.571 33.1295 180.921 35.4995",
    stroke: "white",
    strokeWidth: 0.9592,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6719 2.60938L54.5119 12.1994",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.211 6.13086L119.221 18.7009",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.541 109.739C127.121 109.609 126.741 109.329 126.511 108.899L124.371 104.949C123.911 104.109 124.231 103.059 125.071 102.599C125.911 102.139 126.961 102.459 127.421 103.299L129.561 107.249C130.021 108.089 129.701 109.139 128.861 109.599C128.441 109.829 127.961 109.869 127.541 109.739Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2324 33.8891L38.4224 26.5391L45.1624 28.5391L42.9724 35.8991",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8843 35.0801C37.1114 34.3178 36.4716 33.4545 35.4553 33.1518C34.4391 32.8491 33.4311 33.2215 33.2041 33.9837C32.977 34.7459 33.6168 35.6093 34.6331 35.912C35.6494 36.2147 36.6573 35.8423 36.8843 35.0801Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3121 36.9997C43.5391 36.2375 42.8993 35.3742 41.8831 35.0715C40.8668 34.7687 39.8589 35.1412 39.6318 35.9034C39.4048 36.6656 40.0446 37.5289 41.0608 37.8317C42.0771 38.1344 43.085 37.7619 43.3121 36.9997Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.421 140.58C121.911 129.55 117.741 114.57 117.741 114.57L74.5711 120.33L72.0011 126.11C69.9411 130.74 68.4911 135.61 67.6711 140.59C67.1711 143.74 127.241 146.3 125.421 140.58Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7037 23.5499C95.0274 22.9387 95.0288 20.1222 93.7069 17.2591C92.3849 14.396 90.2401 12.5705 88.9164 13.1817C87.5926 13.7929 87.5912 16.6094 88.9132 19.4725C90.2351 22.3356 92.3799 24.1611 93.7037 23.5499Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2565 26.3441C93.4678 25.3231 93.9109 21.5728 92.2463 17.9676C90.5817 14.3624 87.4397 12.2675 85.2284 13.2885C83.0172 14.3095 82.574 18.0597 84.2387 21.6649C85.9033 25.2702 89.0453 27.3651 91.2565 26.3441Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.701 84.5997C124.821 86.7297 119.971 86.2997 116.901 83.5497C110.591 77.8897 99.8307 68.5297 92.5107 63.6797C81.0707 56.1097 83.5607 41.0897 99.9307 36.9897C113.451 33.6097 127.541 56.6497 133.831 71.9197C135.741 76.5597 133.571 81.9397 128.701 84.5997Z",
    fill: "#FFE8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8508 104.68C47.3608 106.51 64.0308 107.85 68.6508 94.1297C71.6908 85.0997 68.0208 79.8797 74.1108 72.6697C83.6208 61.3997 80.5708 43.7897 66.0808 41.9497C54.1008 40.4397 44.6108 65.2697 40.0508 84.8397C38.6608 90.7697 39.0908 104.02 43.8508 104.68Z",
    fill: "#FFE8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1399 80.3497L73.6299 123.2C73.6299 123.2 80.2899 130.65 102.41 125.12C113.92 122.24 117.76 114.57 117.76 114.57L113.05 68.8697C111.96 60.5297 108.73 52.5497 103.39 46.0497C96.7499 37.9597 88.0799 33.3697 78.5599 37.6197L73.1399 40.0397C58.3899 46.6297 52.1299 64.6797 59.1399 80.3497Z",
    fill: "#FFE8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.4 66.7797C110.91 61.6197 105.04 44.1397 98.43 40.2997C87.84 34.1697 87.5 28.5997 87.5 28.5997C88.83 27.5497 91.29 30.0697 92.7 31.7497C93.28 32.4397 94.36 32.3397 94.79 31.5497C96.23 28.8797 97.94 23.0497 91.05 16.3497C90.22 15.5397 90.91 14.1197 92.06 14.3097C95.01 14.7897 99.51 17.4197 102.79 27.9297C104.65 33.8997 104.77 33.7597 104.77 33.7597C104.77 33.7597 134.14 66.8997 124.7 72.8297C120.54 75.4397 115.98 72.1397 113.4 66.7797Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8398 76.2197C60.2998 70.3797 59.7598 51.8297 64.0698 45.2297C70.9698 34.6697 69.5198 29.4897 69.5198 29.4897C68.0898 29.1697 66.8198 32.6197 66.1698 34.7997C65.8998 35.6897 64.9698 36.1197 64.3698 35.6097C62.3498 33.8897 59.1098 29.4497 62.7598 20.1297C63.1998 19.0097 62.1798 18.0597 61.2898 18.7697C58.9798 20.5997 56.0498 25.1097 56.5898 36.1497C56.8998 42.4097 56.7498 42.3497 56.7498 42.3497C56.7498 42.3497 42.6098 86.1997 52.3098 87.0497C56.5898 87.4197 59.3598 82.2797 59.8398 76.2197Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6909 46.9097L86.3309 30.5297L73.2309 24.7097L68.1309 45.0897C68.1309 45.0897 75.7709 52.7297 86.6909 46.9097Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5818 35.9097L85.1318 47.7097L86.7618 46.8997L86.4218 29.4797L75.7018 22.4897L68.5918 24.6897",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4804 38.2799C90.2057 36.2161 92.6379 28.415 89.913 20.8558C87.1881 13.2966 80.3379 8.84169 74.6126 10.9055C68.8873 12.9693 66.4551 20.7704 69.18 28.3296C71.9049 35.8888 78.7552 40.3437 84.4804 38.2799Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6406 23.8597C83.6406 23.8597 87.7506 27.4497 85.3506 28.5897",
    stroke: "#D9480F",
    strokeWidth: 0.4796,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.37 6.9197C70.37 6.9197 59.3 6.1097 59.99 18.4397C60.71 31.2197 71.8099 33.0097 71.8099 33.0097L69.12 25.5397C69.12 25.5397 72.3 22.6597 75.01 14.5797C75.01 14.5797 81.42 19.3597 88.17 10.7697C88.17 10.7697 85.3899 9.5497 86.3799 5.8097C87.3799 2.0797 73.57 -3.7203 70.37 6.9197Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8003 29.0119C73.1143 27.9229 73.214 25.8749 72.0228 24.4375C70.8316 23.0001 68.8008 22.7177 67.4867 23.8067C66.1727 24.8956 66.073 26.9436 67.2642 28.381C68.4554 29.8184 70.4862 30.1008 71.8003 29.0119Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4102 24.1796C77.5202 25.1296 79.1902 24.9996 80.1402 23.8796",
    stroke: "#D9480F",
    strokeWidth: 0.4796,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.75 21.1097C86.21 21.0697 87.37 19.8597 87.33 18.3997",
    stroke: "#D9480F",
    strokeWidth: 0.4796,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2302 31.3896H87.8002C87.8002 33.3496 86.1902 34.9596 84.2302 34.9596C82.2902 34.9596 80.6902 33.3796 80.6602 31.4496L84.2302 31.3896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.997 35.0809C74.7716 34.1834 76.03 30.3928 74.8078 26.6145C73.5855 22.8361 70.3454 20.5008 67.5708 21.3984C64.7962 22.2959 63.5377 26.0865 64.76 29.8648C65.9822 33.6432 69.2223 35.9785 71.997 35.0809Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6718 34.6305C70.8736 33.9182 71.8717 30.9083 70.901 27.9077C69.9304 24.9071 67.3585 23.0521 65.1567 23.7643C62.9549 24.4766 61.9568 27.4865 62.9275 30.4871C63.8981 33.4877 66.4699 35.3427 68.6718 34.6305Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3702 6.91968C70.3702 6.91968 58.5302 9.23968 65.4702 27.7597",
    stroke: "#FD7E14",
    strokeWidth: 1.9184,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7302 9.33966C71.4102 13.3997 72.9902 20.5997 75.0102 14.5797C75.0102 14.5797 81.4202 19.3597 88.1702 10.7697C88.1702 10.7697 85.3902 9.54966 86.3802 5.80966C87.2002 2.72966 77.9502 -1.76034 72.8902 2.73966C71.0502 4.37966 70.3302 6.91966 70.7302 9.33966Z",
    fill: "#D9480F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicLeftImage);
export default __webpack_public_path__ + "static/media/musicLeftImage.b3c83c05e6ae2c1e4a9cb8f0ae26d19e.svg";
export { ForwardRef as ReactComponent };